import type { PeekPriceHotelCardData } from './accommodation';
import type { PeekPriceBookableTransportCardData } from './transport';

export const enum PeekPriceModalItineraryType {
  // NOTE: This type is used to show old peek price modal as fallback, for trips for which custom view is not available
  OldModal = 'oldModal',
  HotelOnly = 'hotelOnly',
  FlightPlusHotel = 'flightPlusHotel',
  UnavailableFlightPlusHotel = 'unavailableFlightPlusHotel',
  FerryPlusHotel = 'ferryPlusHotel',
  UnavailableFerryPlusHotel = 'unavailableFerryPlusHotel',
}

export interface PeekPriceModalOldModalItinerary {
  type: PeekPriceModalItineraryType.OldModal;
  hotelName: string;
}

export interface PeekPriceModalHotelOnlyItinerary {
  type: PeekPriceModalItineraryType.HotelOnly;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  hotel: PeekPriceHotelCardData;
}

export interface PeekPriceModalFlightPlusHotelItinerary {
  type: PeekPriceModalItineraryType.FlightPlusHotel;
  tripDeparture: string;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  departureTransport: PeekPriceBookableTransportCardData;
  hotel: PeekPriceHotelCardData;
  arrivalTransport: PeekPriceBookableTransportCardData;
}

export interface PeekPriceModalUnavailableFlightPlusHotel {
  type: PeekPriceModalItineraryType.UnavailableFlightPlusHotel;
  paxes: string;
  dates: undefined;
  price: undefined;
}

export interface PeekPriceModalFerryPlusHotelItinerary {
  type: PeekPriceModalItineraryType.FerryPlusHotel;
  tripDeparture: string;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  departureTransport: PeekPriceBookableTransportCardData;
  hotel: PeekPriceHotelCardData;
  arrivalTransport: PeekPriceBookableTransportCardData;
}

export interface PeekPriceModalUnavailableFerryPlusHotel {
  type: PeekPriceModalItineraryType.UnavailableFerryPlusHotel;
  paxes: string;
  dates: undefined;
  price: undefined;
}

export type PeekPriceModalNewModalItinerary =
  | PeekPriceModalHotelOnlyItinerary
  | PeekPriceModalFlightPlusHotelItinerary
  | PeekPriceModalUnavailableFlightPlusHotel
  | PeekPriceModalFerryPlusHotelItinerary
  | PeekPriceModalUnavailableFerryPlusHotel;

export type PeekPriceModalItinerary =
  | PeekPriceModalNewModalItinerary
  | PeekPriceModalOldModalItinerary;
